export const generateId = () => {
  const random = new Uint32Array(1);
  window.crypto.getRandomValues(random);
  return -random[0];
};
